import React, { useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// import JS files

// import others files

const Breadcrumb = (props) => {
  return (
    <>
      <div className="flex">
        {props.list.map((item, index) => {
          return (
            <div className=" text-myblacks-200 text-xs">
              <span>{item}</span>
              {index == props.list.length - 1 ? (
                ""
              ) : (
                <ArrowBackIosNewIcon
                  sx={{ fontSize: "0.75rem" }}
                  className="mx-1"
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Breadcrumb;
